// Pure detection logic for AuthMe-style login/register prompts in chat.
// See issue #527 (auto-fill server login).
const stripFormatting = (text) => {
    return text.replaceAll(/\u00A7./g, '');
};
const LOGIN_CMD_RE = /(?:^|\W)\/login\b/i;
const REGISTER_CMD_RE = /(?:^|\W)\/register\b/i;
const CHANGEPASSWORD_CMD_RE = /(?:^|\W)\/changepassword\b/i;
const UNREGISTER_CMD_RE = /(?:^|\W)\/unregister\b/i;
export const detectLoginPrompt = (text) => {
    if (!text)
        return null;
    const cleaned = stripFormatting(text);
    const hasLogin = LOGIN_CMD_RE.test(cleaned);
    const hasRegister = REGISTER_CMD_RE.test(cleaned);
    const hasChangePassword = CHANGEPASSWORD_CMD_RE.test(cleaned);
    const hasUnregister = UNREGISTER_CMD_RE.test(cleaned);
    if (hasLogin && hasRegister)
        return 'either';
    if (hasLogin)
        return 'login';
    if (hasRegister)
        return 'register';
    if (hasChangePassword)
        return 'changepassword';
    if (hasUnregister)
        return 'unregister';
    return null;
};
export const createLoginPromptDebouncer = (intervalMs = 30_000) => {
    const lastTrigger = new Map();
    return {
        shouldTrigger(serverKey) {
            const now = Date.now();
            const prev = lastTrigger.get(serverKey);
            if (prev !== undefined && now - prev < intervalMs) {
                return false;
            }
            lastTrigger.set(serverKey, now);
            return true;
        },
        reset(serverKey) {
            if (serverKey === undefined) {
                lastTrigger.clear();
            }
            else {
                lastTrigger.delete(serverKey);
            }
        },
    };
};
